const mdfeTranslate = {
  MDFEEncoding: {
    zh: 'MDFE编码',
    en: 'MDFE encoding',
    pu: 'Número MDFE'
  },
  MDFEKey: {
    zh: 'MDFE秘钥',
    en: 'MDFE key',
    pu: 'Chave MDFE'
  },
  AgreementNumber: {
    zh: '协议编号',
    en: 'Agreement Number',
    pu: 'Número do protocolo'
  },
  startingPoint: {
    zh: '起点',
    en: 'starting point',
    pu: 'Origem'
  },
  destination: {
    zh: '目的地',
    en: 'destination',
    pu: 'Destino'
  },
  LockMDFE: {
    zh: '关闭MDFE',
    en: 'Lock MDFE',
    pu: 'Encerrar MDFE'
  },
  CancelMDFE: {
    zh: '取消MDFE',
    en: 'Cancel MDFE',
    pu: 'Cancelar MDFE'
  },
  ViewPDF: {
    zh: '查看PDF',
    en: 'View PDF',
    pu: 'Visualizar PDF'
  },
  BatchCTEPDF: {
    zh: '批量生成CTE PDF',
    en: 'Batch CTE PDF',
    pu: 'CTE em lote PDF'
  },
  ViewDriver: {
    zh: '查看司机',
    en: 'View Driver',
    pu: 'Ver condutores'
  },
  DownloadXml: {
    zh: '下载xml',
    en: 'Download xml',
    pu: 'Baixar xml'
  },
  DownloadXlsx: {
    zh: '下载xlsx',
    en: 'Download xlsx',
    pu: 'Baixar xlsx'
  },
  ChooseVTag: {
    zh: '选择vTag',
    en: 'Choose vTag',
    pu: 'Selectionar vTag'
  },
  Queue: {
    zh: '队列',
    en: 'Queue',
    pu: 'Fila'
  },
  AddVTagToTheQueue: {
    zh: '添加 vTag 到队列',
    en: 'Add vTag to the queue',
    pu: 'adicionar vTag a fila'
  },
  DeleteAll: {
    zh: '全部删除',
    en: 'Delete all',
    pu: 'Limpar tudo'
  },
  SelectedVTags: {
    zh: '选中的 vTags',
    en: 'Selected vTags',
    pu: 'VTags selecionadas'
  },
  ChooseCompany: {
    zh: '选择公司',
    en: 'Choose company',
    pu: 'Escolha a empresa'
  },
  RouteInformation: {
    zh: '路线信息',
    en: 'Route information',
    pu: 'Informações de trajeto'
  },
  source: {
    zh: '来源',
    en: 'source',
    pu: 'Origem'
  },
  quantity: {
    zh: '数量',
    en: 'quantity',
    pu: 'Quantidade'
  },
  cityCode: {
    zh: '城市代码',
    en: 'City code',
    pu: 'Código do município'
  },
  CityName: {
    zh: '城市名称',
    en: 'City name',
    pu: 'Nome do município'
  },
  RoutePoint: {
    zh: '途径点',
    en: 'Route point',
    pu: 'UFs'
  },
  way: {
    zh: '途径点',
    en: 'Route point',
    pu: 'UF'
  },
  DriverAndVehicle: {
    zh: '司机和车辆',
    en: 'Driver and vehicle',
    pu: 'Motorista e veículo'
  },
  TrailerPlateNumber: {
    zh: '拖车车牌号',
    en: 'Trailer plate number',
    pu: 'Placa do caminhão'
  },
  Next: {
    zh: '下一个',
    en: 'Next',
    pu: 'Próximo'
  },
  Previous: {
    zh: '上一个',
    en: 'Previous',
    pu: 'Anterior'
  },
  VTagsQueue: {
    zh: 'vTag 队列',
    en: 'VTag queue',
    pu: 'Fila de vTag'
  },
  SelectTheVTagType: {
    zh: '选择 vTag 类型',
    en: 'Select the vTag type',
    pu: 'Selecione o tipo de vTag'
  },
  ListOfVTags: {
    zh: 'vTag 列表',
    en: 'List of vTag',
    pu: 'Lista de vTag'
  },
  SelectedVTag: {
    zh: '已选中vTag',
    en: 'Selected vTag',
    pu: 'vTag selecionado'
  },
  QuantityOfPackages: {
    zh: '包裹数量',
    en: 'Quantity of packages',
    pu: 'Quantidade de pacotes'
  },
  FreteTotal: {
    zh: '运费总额',
    en: 'Total freight',
    pu: 'Frete total'
  },
  TotalValue: {
    zh: '总价值',
    en: 'Total value',
    pu: 'Valor total'
  },
  TotalWeight: {
    zh: '总重量',
    en: 'Total weight',
    pu: 'Peso total'
  },
  Packages: {
    zh: '包裹',
    en: 'Packages',
    pu: 'Pacotes'
  },
  PlateNumberDoesNotExist: {
    zh: '车牌号不存在',
    en: 'Plate number does not exist',
    pu: 'Placa não existe'
  },
  PostalCodeFormatIsIncorrect: {
    zh: '邮编格式不正确',
    en: 'Postal code format is incorrect',
    pu: 'Código postal não está correto'
  },
  TheAddressCorrespondingToThePostalCodeDoesNotExist: {
    zh: '邮编对应的地址不存在',
    en: 'The address corresponding to the postal code does not exist',
    pu: 'O endereço correspondente ao código postal não existe'
  },
  OperationFailed: {
    zh: '操作失败',
    en: 'Operation Failed',
    pu: 'Falha na Operação'
  },
  PleaseSelectALabel: {
    zh: '请选择标签',
    en: 'Please select a label',
    pu: 'Selecione uma etiqueta'
  },
  StartingStateInconsistent: {
    zh: '起点州不一致',
    en: 'Starting state inconsistent',
    pu: 'Estado inicial inconsistente'
  },
  DestinationStateInconsistent: {
    zh: '终点州不一致',
    en: 'Destination state inconsistent',
    pu: 'Estado final inconsistente'
  },
  ReasonForCancellation: {
    zh: '取消原因',
    en: 'Reason for cancellation',
    pu: 'Motivo do cancelamento'
  },
  AreYouSureYouWantToCloseTheMDFE: {
    zh: '确定关闭MDFE?',
    en: 'Are you sure you want to close the MDFE?',
    pu: 'Tem certeza de que deseja fechar o MDFE?'
  },
  AreYouSureYouWantToCancel: {
    zh: '确定取消吗?',
    en: 'Are you sure you want to cancel?',
    pu: 'Você tem certeza desse cancelamento?'
  },
  PleaseEnterTheCarSign: {
    zh: '请输入车签号',
    en: 'Please enter the car sign',
    pu: 'Digite o sinal do carro'
  },
  ChooseVehicleAndDriver: {
    zh: '选择车辆和司机',
    en: 'Choose vehicle and driver',
    pu: 'Escolha o veículo e o motorista'
  },
  SelectedDriver: {
    zh: '选定的司机',
    en: 'Selected driver',
    pu: 'Motorista selecionado'
  },
  TrailerRENAVAM: {
    zh: '卡车的车辆国家登记号',
    en: 'Trailer RENAVAM',
    pu: 'RENAVAM do caminhão'
  },
  TrailerTare: {
    zh: '卡车皮重',
    en: 'Trailer tare',
    pu: 'Tara do caminhão'
  },
  TrailerCapacity: {
    zh: '卡车容量',
    en: 'Trailer capacity',
    pu: 'Capacidade do caminhão'
  },
  TrailerRNTRC: {
    zh: '卡车RNTRC',
    en: 'Trailer RNTRC',
    pu: 'RNTRC do caminhão'
  },
  TruckDocuments: {
    zh: '货车证件',
    en: 'Truck documents',
    pu: 'Documento do caminhão'
  },
  TruckPlate: {
    zh: '货车车牌',
    en: 'Truck plate',
    pu: 'Placa do caminhão'
  },
  State: {
    zh: '州',
    en: 'State',
    pu: 'Estado UF'
  },
  WheelKind: {
    zh: '车轮类型',
    en: 'Wheel kind',
    pu: 'Tipo de roda'
  },
  VehicleType: {
    zh: '车辆类型',
    en: 'Vehicle type',
    pu: 'Tipo de carro'
  },
  document: {
    zh: '个人/法人税号',
    en: '',
    pu: 'Documento'
  },
  Proprietário: {
    zh: '车辆所属公司',
    en: '',
    pu: 'Proprietário'
  },
  SelectedDriverCannotBeTheSame: {
    zh: '选择的司机不能相同',
    en: 'Selected driver cannot be the same',
    pu: 'O motorista selecionado não pode ser o mesmo'
  },
  PleaseAddDriverAndVehicle: {
    zh: '请添加司机和车辆',
    en: 'Please add driver and vehicle',
    pu: 'Adicione o motorista e o veículo'
  },
  PlateNumberCannotBeRepeated: {
    zh: '车牌号不能重复',
    en: 'Plate number cannot be repeated',
    pu: 'Placa não pode ser repetida'
  },
  Authorized: {
    zh: '已授权',
    en: 'Authorized',
    pu: 'Autorizado'
  },
  PendingReview: {
    zh: '待审核',
    en: 'Pending Review',
    pu: 'Aguardando Revisão'
  },
  Unprocessed: {
    zh: '未处理',
    en: 'Unprocessed',
    pu: 'Não Processado'
  },
  SelectedVehicles: {
    zh: '已选车辆',
    en: 'Selected Vehicles',
    pu: 'Veículos Selecionados'
  },
  Closed: {
    zh: '已关闭',
    en: 'Closed',
    pu: 'Encerrado'
  },
  TotalNumberOfPackages: {
    zh: '包裹总数量',
    en: 'Total number of packages',
    pu: 'Qtd. total de pacotes'
  },
  originalRequestParams: {
    zh: '原始请求参数',
    en: 'Original Request Parameters',
    pu: 'Parâmetros Originais da Requisição'
  },
  responseData: {
    zh: '响应数据',
    en: 'Response Data',
    pu: 'Dados da Resposta'
  },
  CTEExportTemplate: {
    zh: 'CTE导出模板',
    en: 'CTE Export Template',
    pu: 'Modelo de Exportação CTE'
  },
  cteReopen: {
    zh: 'cte补开',
    en: 'cte reopen',
    pu: 'cte reabrir'
  },
  ReopenCteInvoice: {
    zh: '补开cte发票',
    en: 'Reopen cte invoice',
    pu: 'Reabrir a fatura cte'
  },
  BatchCancelInvoice: {
    zh: '批量取消发票',
    en: 'Batch cancel invoice',
    pu: 'Cancelar fatura em lote'
  },
  TaxRateMustBeLessThan1: {
    zh: '税率必须小于1',
    en: 'Tax rate must be less than 1',
    pu: 'Taxa deve ser menor que 1'
  },
  BatchCancelResult: {
    zh: '批量取消结果',
    en: 'Batch cancel result',
    pu: 'Resultado do cancelamento em lote'
  },
  BillingError: {
    zh: '计费错误',
    en: 'Billing Error',
    pu: 'Erro de Cobrança'
  },
  IncorrectRule: {
    zh: '规则有误',
    en: 'Incorrect Rule',
    pu: 'Regra Incorreta'
  },
  CancellationReasonType: {
    zh: '取消原因类型',
    en: 'Cancellation Reason Type',
    pu: 'Tipo de Motivo do Cancelamento'
  },
  PleaseSelectCancellationReasonType: {
    zh: '请选择取消原因类型',
    en: 'Please select cancellation reason type',
    pu: 'Selecione o tipo de motivo do cancelamento'
  },
  PackageNumber: {
    zh: '包裹号',
    en: 'Package Number',
    pu: 'Número da Encomenda'
  },
  InvoiceSecretKey: {
    zh: '发票秘钥',
    en: 'Invoice Secret Key',
    pu: 'Chave Secreta da Fatura'
  },
  ExportByInvoiceKeyOrBusinessOrderNumber: {
    zh: '按发票秘钥或业务单号导出',
    en: 'Export by invoice key or business order number',
    pu: 'Exportar por chave da fatura ou número de ordem de serviço'
  },
  cteKey: {
    zh: 'cte秘钥',
    en: 'cte key',
    pu: 'Chave CTE'
  },
  compartmentDataCleanup: {
    zh: '格口数据清理',
    en: 'Compartment Data Cleanup',
    pu: 'Limpeza de Dados de Compartimento'
  },
  cleanupDataUntilTime: {
    zh: '清理数据截至时间',
    en: 'Cleanup Data Until Time',
    pu: 'Limpar Dados Até o Tempo'
  },
  clickToCleanup: {
    zh: '点击清理',
    en: 'Click to Cleanup',
    pu: 'Clique para Limpar'
  },
  taskProgress: {
    zh: '任务进度',
    en: 'Task Progress',
    pu: 'Progresso da Tarefa'
  },
  totalTasks: {
    zh: '任务总数',
    en: 'Total Tasks',
    pu: 'Total de Tarefas'
  },
  successfulTasks: {
    zh: '成功总数',
    en: 'Successful Tasks',
    pu: 'Tarefas Bem-sucedidas'
  },
  failedTasks: {
    zh: '失败总数',
    en: 'Failed Tasks',
    pu: 'Tarefas Com Falha'
  },
  selectedData: {
    zh: '已选数据',
    en: 'Selected Data',
    pu: 'Dados Selecionados'
  },
  tip0815: {
    zh: '请输入8-14位数字',
    en: 'Selected Data',
    pu: 'Digite de 8 a 14 dígitos'
  },
  tip8Number: {
    zh: '请输入8位纯数字',
    en: '',
    pu: 'Digite 8 dígitos numéricos'
  },
  Coleta: {
    zh: '揽收',
    en: 'Pickup',
    pu: 'Coleta'
  },
  Entrega: {
    zh: '派送',
    en: 'Delivery',
    pu: 'Entrega'
  },
  CarrierSignatureRepeated: {
    zh: '车签号重复',
    en: 'Carrier Signature Repeated',
    pu: 'Carimbo de Carreira Repetido'
  },
  ReopenCTeInvoiceResult: {
    zh: '补开cte发票结果',
    en: 'Reopen CT-e Invoice Result',
    pu: 'Resultado da Reabertura da Fatura CT-e'
  },
  tipPrefix: {
    zh: '如果有多个邮箱，则用英语逗号隔开',
    en: '',
    pu: 'Separe por vírgula se houver várias'
  },
  batchImportEmails: {
    zh: '批量导入对账邮箱',
    en: 'Batch Import Emails',
    pu: 'Importação em Lote de Emails'
  },
  uploadEmailFile: {
    zh: '请上传要导入的邮箱文件',
    en: 'Please upload the email file to import',
    pu: 'Por favor carregue o arquivo de email para importar'
  },
  multipleLineInput: {
    zh: '多个换行输入，单次最多支持10w条',
    en: 'Multiple line input, supports up to 100,000 entries at a time',
    pu: 'Entrada de múltiplas linhas, suporta até 100.000 entradas por vez'
  },
  reconciliationEmail: {
    zh: '对账邮箱',
    en: 'Reconciliation Email',
    pu: 'Email de Reconciliação'
  },
  queryLimitNotice: {
    zh: '单次查询最多10万条，已截取前10万条',
    en: 'Maximum 100,000 records per query, first 100,000 records retrieved',
    pu: 'Máximo de 100.000 registros por consulta, primeiros 100.000 registros recuperados'
  },
  reconciliationEmailTemplate: {
    zh: '对账邮箱模板.csv',
    en: 'Reconciliation Email Template.csv',
    pu: 'Modelo de Email de Reconciliação.csv'
  },
  CTEReopenConfirmation: {
    zh: 'CTE补开确认',
    en: 'CTE Reopen Confirmation',
    pu: 'Confirmação de Reabertura de CTE'
  },
  PleaseConfirmWhetherToReopenTheAboveOrderDataCTE: {
    zh: '请确认是否补开以上订单数据CTE',
    en: 'Please confirm whether to reopen the above order data CTE',
    pu: 'Confirme se deseja reabrir os dados de ordem CTE acima'
  },
  PleaseAgainConfirmWhether: {
    zh: '请二次确认是否补开以上订单数据CTE',
    en: 'Please again confirm whether to reopen the above order data CTE',
    pu: 'Confirme novamente se deseja reabrir os dados de ordem CTE acima'
  },
  CTEBindingBatchNumber: {
    zh: 'CTE绑定批单号',
    en: 'CTE Binding Batch Number',
    pu: 'Número de Lote de Vinculação CTE'
  },
  regularExpress: {
    zh: '普通快递',
    en: 'Regular Express',
    pu: 'Expresso Regular'
  },
  largeParcelExpress: {
    zh: '大件快递',
    en: 'Large Parcel Express',
    pu: 'Expresso de Grande Porte'
  },
  ForceClose: {
    zh: '强制关闭',
    en: 'Force Close',
    pu: 'Fechar Forçado'
  },
  CompanyTaxNumber: {
    zh: '公司税号',
    en: 'Company Tax Number',
    pu: 'Número de Imposto da Empresa'
  },
  EndState: {
    zh: '结束州',
    en: 'End State',
    pu: 'Estado Final'
  },
  EndCity: {
    zh: '结束城市',
    en: 'End City',
    pu: 'Cidade Final'
  },
  AreYouSureYouWantToForceClose: {
    zh: '确定要强制关闭吗？',
    en: 'Are you sure you want to force close?',
    pu: 'Tem certeza de que deseja fechar forçado?'
  },
  OnlyNumbersCanBeEntered: {
    zh: '只能输入数字',
    en: 'Only numbers can be entered',
    pu: 'Só números podem ser inseridos'
  },
  MessageBody: {
    zh: '消息体',
    en: 'Message Body',
    pu: 'Corpo da Mensagem'
  },
  AreYouSureYouWantToRegenerate: {
    zh: '确定重新生成吗？',
    en: 'Are you sure you want to regenerate?',
    pu: 'Tem certeza de que deseja regenerar?'
  },
  GeneratingPDF: {
    zh: '生成PDF中...',
    en: 'Generating PDF...',
    pu: 'Gerando PDF...'
  },
  ProcessingBlock: {
    zh: '处理第',
    en: 'Processing Block',
    pu: 'Processando Bloco'
  },
  Blocks: {
    zh: '块',
    en: '',
    pu: ''
  },
  Preparing: {
    zh: '准备中...',
    en: 'Preparing...',
    pu: 'Preparando...'
  },
  PDFGenerationFailed: {
    zh: 'PDF生成失败',
    en: 'PDF generation failed',
    pu: 'Falha na geração do PDF'
  },
  ConvertingImage: {
    zh: '转换图片中...',
    en: 'Converting image...',
    pu: 'Convertendo imagem...'
  },
  DownloadBaseInvoiceBasicInformation: {
    zh: '下载基票据本信息',
    en: 'Download Base Invoice Basic Information',
    pu: 'Baixar Base Invoice Basic Information'
  },
  DownloadAllInvoiceInformation: {
    zh: '下载票据全部信息',
    en: 'Download Invoice All Information',
    pu: 'Baixar Todas as Informações da Fatura'
  },
  ViewInvoiceBasicInformation: {
    zh: '查看票据基本信息',
    en: 'View Invoice Basic Information',
    pu: 'Ver Informações Básicas da Fatura'
  },
  ViewInvoiceAllInformation: {
    zh: '查看票据全部信息',
    en: 'View Invoice All Information',
    pu: 'Ver Todas as Informações da Fatura'
  },
  ExportNFSeInvoice: {
    zh: '导出NFSe发票',
    en: 'Export NFSe Invoice',
    pu: 'Exportar Fatura NFSe'
  },
  NewCteInvoice: {
    zh: '新开cte发票',
    en: 'New cte Invoice',
    pu: 'Nova Fatura Cte'
  },
  PleaseConfirmWhetherToOpenNewOrderDataCTE: {
    zh: '请确认是否新开以上订单数据CTE',
    en: 'Please confirm whether to open a new order data CTE',
    pu: 'Confirme se deseja abrir os dados de ordem CTE acima'
  },
  PleaseAgainConfirmWhetherToOpenNewOrderDataCTE: {
    zh: '请二次确认是否新开以上订单数据CTE',
    en: 'Please again confirm whether to open a new order data CTE',
    pu: 'Confirme novamente se deseja abrir os dados de ordem CTE acima'
  },
  CTENewConfirmation: {
    zh: 'CTE新开确认',
    en: 'CTE New Confirmation',
    pu: 'Confirmação de Nova CTE'
  },
  UpdateCnpjInformation: {
    zh: '更新cnpj信息',
    en: 'Update cnpj information',
    pu: 'Atualizar informações cnpj'
  },
  GetLatestInformation: {
    zh: '获取最新信息',
    en: 'Get latest information',
    pu: 'Obter informações mais recentes'
  },
  sureUpdateCnpjInformation: {
    zh: '确定要更新cnpj信息吗？',
    en: 'Are you sure you want to update cnpj information?',
    pu: 'Tem certeza de que deseja atualizar as informações cnpj?'
  },
  PleaseEnter12Digits: {
    zh: '请输入12位数字',
    en: 'Please enter 12 digits',
    pu: 'Digite 12 dígitos'
  },
  PleaseSelectBusinessType: {
    zh: '请选择业务类型',
    en: 'Please select business type',
    pu: 'Selecione o tipo de negócio'
  },
  RepeatedWaybillNumber: {
    zh: '重复运单号',
    en: 'Repeated Waybill Number',
    pu: 'Número de Rota Repetido'
  },
  ViewQRCode: {
    zh: '查看二维码',
    en: 'View QR Code',
    pu: 'Ver Código QR'
  },
  MostlyQuery100WaybillNumbers: {
    zh: '最多查询100个车签号',
    en: 'Mostly query 100 waybill numbers',
    pu: 'Mais de 100 números de rota'
  },
  LoadNumber: {
    zh: '装载单号',
    en: 'Load Number',
    pu: 'Número de Carga'
  },
  CargoHandler: {
    zh: '商品货运员',
    en: 'Cargo Handler',
    pu: 'Cargador de Mercadoria'
  },
  InvoiceCode: {
    zh: '商品发票代码',
    en: 'Invoice Code',
    pu: 'Código da Fatura'
  },
  InvoiceAmount: {
    zh: '商品发票金额',
    en: 'Invoice Amount',
    pu: 'Valor da Fatura'
  },
  InvoiceSerialNumber: {
    zh: '商品发票序列号',
    en: 'Invoice Serial Number',
    pu: 'Número de Série da Fatura'
  },
  InvoiceTime: {
    zh: '商品发票时间',
    en: 'Invoice Time',
    pu: 'Data da Fatura'
  },
  LogisticsInvoiceKey: {
    zh: '物流发票秘钥',
    en: 'Logistics invoice key',
    pu: 'Chave da Fatura de Logística'
  },
  LogisticsCargoHandler: {
    zh: '物流货运员',
    en: 'Logistics Cargo Handler',
    pu: 'Cargador de Logística'
  },
  LogisticsInvoiceCode: {
    zh: '物流发票代码',
    en: 'Logistics Invoice Code',
    pu: 'Código da Fatura de Logística'
  },
  LogisticsInvoiceAmount: {
    zh: '物流发票金额',
    en: 'Logistics Invoice Amount',
    pu: 'Valor da Fatura de Logística'
  },
  BuyerTaxNumber: {
    zh: '买家税号',
    en: 'Buyer Tax Number',
    pu: 'Número de Imposto do Comprador'
  },
  BuyerPostalCode: {
    zh: '买家邮政编码',
    en: 'Buyer Postal Code',
    pu: 'Código Postal do Comprador'
  },
  BuyerAddress: {
    zh: '买家地址',
    en: 'Buyer Address',
    pu: 'Endereço do Comprador'
  },
  BuyerDetailedAddress: {
    zh: '买家详细地址',
    en: 'Buyer Detailed Address',
    pu: 'Endereço Detalhado do Comprador'
  },
  BuyerEmail: {
    zh: '买家邮箱',
    en: 'Buyer Email',
    pu: 'Email do Comprador'
  },
  BuyerNameCompanyNameOrPersonalName: {
    zh: '买家名称，公司名或个人名称',
    en: 'Buyer Name, Company Name or Personal Name',
    pu: 'Nome do Comprador, Nome da Empresa ou Nome Pessoal'
  },
  sameHubOperationNotAllowed: {
    zh: '不允许操作同一网点数据',
    en: 'Operation on same hub data not allowed',
    pu: 'Operação nos mesmos dados do centro não permitida'
  },
  YearAndMonth: {
    zh: '年月',
    en: 'Year and month',
    pu: 'Ano e mês'
  },
  OnlyCollect: {
    zh: '仅揽收',
    en: 'Only collect',
    pu: 'Somente coleta'
  },
  OnlySend: {
    zh: '仅派送',
    en: 'Only send',
    pu: 'Somente envio'
  },
  OnlyTotal: {
    zh: '仅总数',
    en: 'Only total',
    pu: 'Somente total'
  },
  TotalNumberDeliveries: {
    zh: '派送数量',
    en: 'Total number of deliveries',
    pu: 'Número total de envios'
  },
  HighestCollectionAmount: {
    zh: '最高揽收量',
    en: 'Highest collection amount',
    pu: 'Maior quantidade de coleta'
  },
  HighestDeliveryAmount: {
    zh: '最高派送量',
    en: 'Highest delivery amount',
    pu: 'Maior quantidade de envio'
  },
  HighestTotal: {
    zh: '最高总量',
    en: 'Highest total',
    pu: 'Maior total'
  },
  AverageDailyTotal: {
    zh: '平均每日总量',
    en: 'Average daily total',
    pu: 'Total médio diário'
  },
  dayAverage: {
    zh: '天平均',
    en: 'Day average',
    pu: 'Média de dia'
  },
  FirstWeek: {
    zh: '第1周',
    en: 'First week',
    pu: 'Primeira Semana'
  },
  SecondWeek: {
    zh: '第2周',
    en: 'Second week',
    pu: 'Segunda Semana'
  },
  ThirdWeek: {
    zh: '第3周',
    en: 'Third week',
    pu: 'Terceira Semana'
  },
  FourthWeek: {
    zh: '第4周',
    en: 'Fourth week',
    pu: 'Quarta Semana'
  },
  FifthWeek: {
    zh: '第5周',
    en: 'Fifth week',
    pu: 'Quinta Semana'
  },
  ClearSelection: {
    zh: '清空勾选',
    en: 'Clear selection',
    pu: 'Limpar seleção'
  },
  FreightAmountTax: {
    zh: '运费金额(含税)',
    en: 'Freight amount (tax included)',
    pu: 'Valor da Frete (incluindo impostos)'
  },
  FreightAmountNoTax: {
    zh: '运费金额(不含税)',
    en: 'Freight amount (tax excluded)',
    pu: 'Valor da Frete (sem impostos)'
  },
  MostlyQuery10Plates: {
    zh: '最多查询10个车牌号',
    en: 'Mostly query 10 plates',
    pu: 'Mais de 10 placas'
  },
  each10PlatesNumber: {
    zh: '多个车牌号换行输入,每次最多查询10个车牌号',
    en: 'Multiple plates number enter a line, each time up to 10 plates number',
    pu: 'Múltiplas placas número de enter uma linha, cada vez até 10 placas número'
  },
  CTEKey: {
    zh: 'CT-e秘钥',
    en: 'CT-e key',
    pu: 'Chave da CT-e'
  },
  VehicleOperationMode: {
    zh: '车辆运营模式',
    en: 'Vehicle operation mode',
    pu: 'Modo de operação do veículo'
  },
  SystemAutomatic: {
    zh: '系统自动',
    en: 'System automatic',
    pu: 'Sistema automático'
  },
  UserManual: {
    zh: '用户手动',
    en: 'User manual',
    pu: 'Manual do usuário'
  },
  OperatorAccount: {
    zh: '操作人账号',
    en: 'Operator account',
    pu: 'Conta do Operador'
  },
  TotalOrderQuantity: {
    zh: '总订单数量',
    en: 'Total order quantity',
    pu: 'Quantidade total de pedidos'
  },
  RepeatOrderNumberQuantity: {
    zh: '重复单号数量',
    en: 'Repeat order number quantity',
    pu: 'Quantidade de números de ordem repetidos'
  },
  RepeatDetails: {
    zh: '重复明细',
    en: 'Repeat details',
    pu: 'Detalhes repetidos'
  },
  RepeatRate: {
    zh: '重复率',
    en: 'Repeat rate',
    pu: 'Taxa de repetição'
  },
  DataExclusion: {
    zh: '数据剔除',
    en: 'Data exclusion',
    pu: 'Exclusão de dados'
  },
  SelectedVTagQueue: {
    zh: '已选择vTag队列',
    en: 'Selected vTag queue',
    pu: 'Fila vTag selecionada'
  },
  PleaseEnterVTagKey: {
    zh: '请输入vTag',
    en: 'Please enter vTag',
    pu: 'Por favor, insira vTag'
  },
  mdfeQueue: {
    zh: 'mdfe队列',
    en: 'mdfe queue',
    pu: 'Fila mdfe'
  },
  PleaseEnterMdfeKey: {
    zh: '请输入mdfe秘钥',
    en: 'Please enter mdfe key',
    pu: 'Por favor, insira a chave mdfe'
  },
  SelectedMdfeQueue: {
    zh: '已选择mdfe队列',
    en: 'Selected mdfe queue',
    pu: 'Fila mdfe selecionada'
  },
  mdfeKeyRepeat: {
    zh: 'mdfe秘钥重复',
    en: 'mdfe key repeat',
    pu: 'Chave mdfe repetida'
  },
  LoadingDataExclusion: {
    zh: '装车重复数据剔除',
    en: 'Loading data exclusion',
    pu: 'Exclusão de dados de carregamento'
  },
  CarrierNumberAssociatedWithNumberPackages: {
    zh: '车签号关联包裹数',
    en: 'Carrier number associated with the number of packages',
    pu: 'Número de pacotes associados ao número de carregamento'
  },
  RepeatPackages: {
    zh: '重复包裹数',
    en: 'Repeat packages quantity',
    pu: 'Quantidade de pacotes repetidos'
  },
  PleaseConfirmAgainWhetherExcludeAboveRepeatOrderNumbers: {
    zh: '请再次确认是否剔除以上重复单号？',
    en: 'Please confirm again whether to exclude the above repeat order numbers?',
    pu: 'Por favor, confirme novamente se deseja excluir os números de ordem repetidos?'
  },
  SelectedVTagQueueCannotBeEmpty: {
    zh: '已选择 vTag 队列不能为空',
    en: 'Selected vTag queue cannot be empty',
    pu: 'A fila vTag selecionada não pode estar vazia'
  },
  SelectedMdfeQueueCannotEmpty: {
    zh: '已选择 mdfe 队列不能为空',
    en: 'Selected mdfe queue cannot be empty',
    pu: 'A fila mdfe selecionada não pode estar vazia'
  },
  NewCteInvoiceResult: {
    zh: '新开cte发票结果',
    en: 'New cte invoice result',
    pu: 'Resultado de nova cte fatura'
  },
  RepeatRateConfiguration: {
    zh: '重复率配置',
    en: 'Repeat rate configuration',
    pu: 'Configuração de taxa de repetição'
  },
  OnlyNumbersBetween0And100Entered: {
    zh: '只能输入0到100的数字',
    en: 'Only numbers between 0 and 100 can be entered',
    pu: 'Apenas números entre 0 e 100 podem ser inseridos'
  },
  CheckDownload: {
    zh: '勾选下载',
    en: 'Check download',
    pu: 'Marque para baixar'
  },
  DownloadByNumber: {
    zh: '按号码下载',
    en: 'Download by number',
    pu: 'Baixar por número'
  },
  downloadExceed2000: {
    zh: '单次下载数据不能超过2000条',
    en: 'Single download data cannot exceed 2000 lines',
    pu: 'Os dados de download não podem exceder 2000 linhas'
  },
  modifyTheRepeatRate: {
    zh: '确定要修改重复率吗？',
    en: 'Are you sure you want to modify the repeat rate?',
    pu: 'Tem certeza de que deseja modificar a taxa de repetição?'
  },
  AbnormalMdfe: {
    zh: '异常mdfe',
    en: 'Abnormal mdfe',
    pu: 'Mdfe anormal'
  },
  AbnormalMdfeProcessing: {
    zh: '异常mdfe处理',
    en: 'Abnormal mdfe processing',
    pu: 'Processamento de mdfe anormal'
  },
  PleaseEnterAbnormalMDFE: {
    zh: '请输入异常MDFE',
    en: 'Please enter an abnormal MDFE',
    pu: 'Por favor, insira um MDFE anormal'
  },
  PleaseConfirmWhetherOperation: {
    zh: '请确认是否执行操作？',
    en: 'Please confirm whether to execute the operation?',
    pu: 'Por favor, confirme se deseja executar a operação?'
  },
  CustomerCode: {
    zh: '客户编码',
    en: 'Customer code',
    pu: 'Código do cliente'
  },
  InvoiceCNPJ: {
    zh: '开票CNPJ',
    en: 'Invoice CNPJ',
    pu: 'CNPJ de fatura'
  },
  InvoiceIE: {
    zh: '开票IE',
    en: 'Invoice IE',
    pu: 'IE de fatura'
  },
  CompanyAbbreviation: {
    zh: '公司简称',
    en: 'Company abbreviation',
    pu: 'Abreviação da empresa'
  },
  CompanyFullName: {
    zh: '公司全称',
    en: 'Company full name',
    pu: 'Nome completo da empresa'
  },
  StateAbbreviationUF: {
    zh: '州缩写UF',
    en: 'State abbreviation UF',
    pu: 'Abreviação do estado UF'
  },
  Street: {
    zh: '街区',
    en: 'Street',
    pu: 'Rua'
  },
  SupplementalAddress: {
    zh: '补充地址',
    en: 'Supplemental address',
    pu: 'Endereço complementar'
  },
  IBGECode: {
    zh: 'IBGE代码',
    en: 'IBGE code',
    pu: 'Código IBGE'
  },
  ValidityPeriod: {
    zh: '有效期',
    en: 'Validity period',
    pu: 'Período de validade'
  },
  StartTimeCannotLessCurrentTime: {
    zh: '起始时间不能小于当前时间',
    en: 'Start time cannot be less than the current time',
    pu: 'A data de início não pode ser menor que a data atual'
  },
  StartTimeCannotGreaterThanEqualEndTime: {
    zh: '起始时间不能大于或等于结束时间',
    en: 'Start time cannot be greater than or equal to the end time',
    pu: 'A data de starting não pode ser maior ou igual à data de finalização'
  },
  RequestParameters: {
    zh: '请求参数',
    en: 'Request parameters',
    pu: 'Parâmetros de solicitação'
  },
  ResponseParameters: {
    zh: '响应参数',
    en: 'Response parameters',
    pu: 'Parâmetros de resposta'
  },
  ChangeField: {
    zh: '变更字段',
    en: 'Change field',
    pu: 'Campo de alteração'
  },
  OldValue: {
    zh: '旧值',
    en: 'Old value',
    pu: 'Valor antigo'
  },
  NewValue: {
    zh: '新值',
    en: 'New value',
    pu: 'Novo valor'
  },
  OneClickFillIn: {
    zh: '一键填入',
    en: 'One click fill in',
    pu: 'Um clique para preencher'
  },
  enter11Digits14: {
    zh: '请输入11位或者14位数字或字母，注意：最后两位必须是数字',
    en: 'Please enter 11 digits or 14 digits number or letter, note: the last two digits must be numbers',
    pu: 'Por favor, insira 11 dígitos ou 14 dígitos número ou letra, nota: os dois últimos dígitos devem ser números'
  },
  SingleMostQuery2000MDFEKey: {
    zh: '单次最多查询2000个MDFE秘钥',
    en: 'Single most query 2000 MDFE key',
    pu: 'Mais de 2000 chaves MDFE'
  },
  BatchNumber: {
    zh: '批次号',
    en: 'Batch number',
    pu: 'Número de lote'
  },
  PleaseEnter9To12Digits: {
    zh: '请输入9到12位数字',
    en: 'Please enter 9 to 12 digits',
    pu: 'Por favor, insira 9 a 12 dígitos'
  },
  PolicyBatchNumber: {
    zh: '保单批号',
    en: 'Policy Batch Number',
    pu: 'Número do Lote da Apólice'
  },
  InProgress: {
    zh: '进行中',
    en: 'In progress',
    pu: 'Em andamento'
  }
};
export { mdfeTranslate };
